import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Table,
  Modal,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import $ from "jquery";
import LoadingOverlay from 'react-loading-overlay';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import "./styles.css";
import exportToCSVNew from '../../../Common/exportcsvnew';
import exportToCSV from '../../../Common/exportcsv';

var url = window.location.hostname;
var port = window.location.port;
const Heading = [["UserName", "Password", "Response", "Remarks"]]

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    //handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
    this.ConfirmToggle = this.ConfirmToggle.bind(this);
    this.openConfirm = this.openConfirm.bind(this);

    /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
      loading_overlay: false,
      bulkuser_header: [
        {
          "username": "",
          "employee_code": "",
          "fullname": "",
          "role": "",
          "warehouse": "",
          "email": "",
          "mobile": "",
          "city": "",
          "inv_owner": ""
        },
      ],

      showPassword: false,
      responseModal: false,
      responseModalMsg: null,
      btnDisabled: false,
      file: {},
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,
      isLoading: true,
      user_file: '',
      responseUserFailedData: [],
      showUserDetails: false,
      responseUserSuccessData: [],
      filtered_orderData: []

    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  responseModalToggle = () => {
    this.setState({
      responseModal: !this.state.responseModal
    });
  }


  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = Util.getCookie("token");
    var location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: location,
      },
      () => {
        //this.config_zoneDropDown();
        //this.zoneDropdown();
      }
    );

    localStorage.setItem("userName", username);
  }

  SuccesstoggleCancel() {
    this.setState(
      {
        Successmodal: false,
      }
    );

  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  ConfirmToggle() {
    this.setState((prevState) => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm() {
    this.setState({
      ConfirmModal: true,
    });
  }

  togglePressCancel() {

    this.setState({
      modal: false,
      modalFailed: false,
    });
  }

  handleChange(evt) {
    const files = evt.target.files;
    var file1 = evt.target.value;
    let fd = new FormData();
    fd.append('file', files[0]);
    this.setState({
      btnDisabled: true,
      loading_overlay: true,
      "user_file": fd
    }, () => {

      if (files && files[0]) {
        this.setState({
          file: files[0]
        })
      } else {
        this.setState({
          loading_overlay: false,
          btnDisabled: false,
          file: {},
        })
        $(".upload_success").css('display', 'none');
        $(".upload_error").css('display', 'none');
        $('.button_enable').removeAttr('disabled', 'disabled');
        return false;
      };

      var fileArray1 = file1.split(".");
      var extension1 = fileArray1[fileArray1.length - 1];

      if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color = "";
        document.getElementById("my_file_input").style.width = "85%";
        document.getElementById("picking_label").style.display = "none";
      } else {
        document.getElementById("my_file_input").style.width = "26%";
      }

      if (extension1 != "xlsx" && extension1 != "csv" && extension1 != "xls") {
        $(".upload_error").css("display", "block");
        $(".upload_success").css("display", "none");
      } else {
        $(".upload_success").css("display", "block");
        $(".upload_error").css("display", "none");
        $(".button_enable").removeAttr("disabled", "disabled");
      }

      this.setState({
        btnDisabled: false,
        loading_overlay: false,
      });
    });
  }


  handleFile() {
    /* Boilerplate to set up FileReader */
    // console.log("fdddddd",fd);

    if (this.state.file.name === undefined || this.state.file.name === null) {
      this.setState({
        responseModal: true,
        responseModalMsg: "Select at least one File"
      });
      return false;
    }
    this.setState({
      loading: true,
      loading_overlay: true,
    });
    API.post('/auth/create-employee/', { param: this.state.user_file })
      .then((response) => response.data)
      .then((data) => {
        let failed_data = data.employees_failed.map((item, index) => {
          return {
            username: item.username,
            password: '',
            error: item.error,
            message: item.message
          }
        })
        this.setState({
          responseUserFailedData: failed_data,
          responseUserSuccessData: data.employees_created,
          loading: false,
          loading_overlay: false,
          showUserDetails: true,

        });
      })
      .catch((error) => {
        try {
          if (error.response.status == "400") {
            let failed_data = error.response.data.employees_failed.map((item, index) => {
              return {
                username: item.username,
                password: '',
                message: item.message,
                error: item.error,
              }
            })
    
            this.setState({
              responseUserFailedData: failed_data,
              responseUserSuccessData: error.response.data.employees_created,
              showUserDetails: true,
              loading: false,
              loading_overlay: false,
            });
          }
        }
        catch (err) {
          this.setState({
            loading: false,
            loading_overlay: false,
            modalFailed : true

          })
        }
      });
  }

  render() {
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;

    return (

      <Col xl={12}>
        {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' />}
        <Card>
          <CardBody style={{ height: 220, paddingTop: 0 }}>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={e => e.preventDefault()}>
              <div
                className="form__form-group col-xl-5"
                style={{ marginBottom: "0px" }}
              >
                <div className="row">
                  <div
                    className="col-xl-12"
                    style={{ border: "1px solid #f2f4f7" }}
                  >
                    <input
                      style={{
                        paddingTop: 8,
                        height: 38,
                        color: "transparent",
                        width: "26%",
                        border: "0px",
                      }}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"

                      id="my_file_input"
                      onChange={this.handleChange}
                      ref={ref => this.fileInput = ref}
                    />
                    <label for="files" id="picking_label">
                      Select and Upload User Details
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error"
                    >
                      {" "}
                      Invalid file format. Please select .xls, .xlsx, .csv file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={this.handleFile}
                    disabled={this.state.btnDisabled}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>
            </form>



            <div style={{ paddingLeft: "17px" }}>
              <button
                color="primary"
                className="download_sample_styling button_enable "
                style={{
                  backgroundColor: "#fff",
                  marginTop: 4,
                  marginBottom: 7,
                  fontWeight: "500",
                  textDecoration: "underline",
                  textTransform: "capitalize",
                }}
                onClick={(e) =>
                  exportToCSVNew(
                    this.state.bulkuser_header,
                    "Bulk_User_Template"
                  )
                }
              >
                Sample Template
              </button>
              <div className="notes" style={{ paddingTop: "15px", display: 'none' }}>
                <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                  <b>Note</b> : 1. All fields are mandatory.
                </p>
                <p
                  style={{
                    marginBottom: "13px",
                    fontSize: "15px",
                    paddingLeft: "46px",
                  }}
                >
                  2. Possible value for LB Type are (0, 2) : 0 = saleable, 2 =
                  Outer Cartons.
                </p>
                <p
                  style={{
                    marginBottom: "13px",
                    fontSize: "15px",
                    paddingLeft: "46px",
                  }}
                >
                  3. Make two separate entries : one for saleable and another
                  for outer carton for basepacks having OCLD Flag as "Yes" in
                  the Product Master.
                </p>
              </div>
            </div>
          </CardBody>

          {this.state.showUserDetails && (
            <CardBody style={{ marginTop: 20 }}>
              <div
                className="table_header"
                style={{ borderBottomWidth: "0px" }}
              >
                <h4
                  style={{
                    fontWeight: "bold",
                    width: "80%",
                    paddingTop: 10,
                    float: "left",
                  }}
                  className="subhead red-text"
                >
                  Created/Uncreated Users
                </h4>

                <span
                  className="pull-right"
                  onClick={() =>
                    exportToCSV(this.state.responseUserSuccessData.concat(this.state.responseUserFailedData), "Created/Uncreated Users", Heading)
                  }
                  style={{
                    fontSize: "17px",
                    paddingRight: "0px",
                    cursor: "pointer",
                    color: "#919193",
                    paddingTop: "9px",
                  }}
                >
                  <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                </span>
              </div>

              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>UserName</th>
                    <th>Password</th>
                    <th>Response</th>
                    <th>Remarks</th>

                  </tr>
                </thead>
                <tbody>
                  {this.state.responseUserFailedData.length >
                    0 &&
                    this.state.responseUserFailedData.map(
                      (item, index) => (
                        <tr>
                          <td>{item.username}</td>
                          <td></td>
                          <td style={{ color: "red" }}>{item.message}</td>
                          <td>{item.error}</td>
                        </tr>
                      )
                    )}
                  {this.state.responseUserSuccessData.length >
                    0 &&
                    this.state.responseUserSuccessData.map(
                      (item, index) => (
                        <tr>
                          <td>{item.username}</td>
                          <td>{item.password}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                          <td>{item.error}</td>
                        </tr>
                      )
                    )}

                </tbody>
              </Table>
            </CardBody>
          )}

        </Card>
        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Updated</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccesstoggleCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={this.state.responseModal}
          toggle={this.responseModalToggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.responseModalToggle} />


          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{ color: 'red' }} />
            <h4>{this.state.responseModalMsg}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#ddd', color: '#fff' }} className="modal_ok" onClick={this.responseModalToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>


      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));